import { useEffect } from "react";

const MagicLogin = ({ loginVerification }) => {
  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");

    if (token) {
      localStorage.setItem("token", token);
      loginVerification();
    }
  }, []);

  return <p>Logging you in...</p>;
};

export default MagicLogin;
